<template>
    <nav class="navbar navbar-expand-lg sticky-top" :class="{ 'nav-dark': $route.name == 'Home' }">
        <div class="container">
            <router-link to="/" class="navbar-brand" @click.native="closeMenu">
                C-SUITE <span>Labs</span>
            </router-link>
            <button class="navbar-toggler" type="button" :aria-expanded="show" @click.prevent="openMenu" aria-label="menu">
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 5 8 A 2.0002 2.0002 0 1 0 5 12 L 45 12 A 2.0002 2.0002 0 1 0 45 8 L 5 8 z M 5 23 A 2.0002 2.0002 0 1 0 5 27 L 45 27 A 2.0002 2.0002 0 1 0 45 23 L 5 23 z M 5 38 A 2.0002 2.0002 0 1 0 5 42 L 45 42 A 2.0002 2.0002 0 1 0 45 38 L 5 38 z"/></svg>
            </button>
            <hr />
            <div id="mainNav" ref="navbar" class="collapse navbar-collapse" :class={show}>
                <ul class="navbar-nav">
                    <li class="nav-item" v-for="(nav, index) in navigation" :key="index">
                        <router-link :to="nav.path" class="nav-link" @click.native="closeMenu">{{ nav.name }}</router-link>
                    </li>
                </ul>
                <div class="contact-us">
                    <btn v-b-modal.modal-contact-form primary rounded>Contact Us</btn>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import Btn from '@/components/global/Btn.vue';

export default {
    name: 'app-nav',

    components: {
        Btn,
    },

    data() {
        return {
            show: false,
            navigation: [
                {
                    path: '/portfolio',
                    name: 'Portfolio',
                },
                {
                    path: '/services',
                    name: 'Services',
                },
                {
                    path: '/people',
                    name: 'People',
                },
                {
                    path: '/about',
                    name: 'About',
                },
            ],
        };
    },

    methods: {
        closeMenu() {
            this.show = false;
        },

        openMenu() {
            this.show = !this.show;
        },
    },
};
</script>

<style lang="scss" scoped>
/* Default navbar color */
$nav-text-color-hover: $primary;
$nav-text-color: $secondary;
$nav-bg-color: #ffffff;
$nav-border-color: #f2f2f2;

nav.navbar {
    position: relative;
    padding-top: 15px;
    padding-bottom: 15px;
    background-color: $nav-bg-color;
    color: $nav-text-color;
    box-shadow: 0 0 8px rgba(0, 0, 0, .101562);
    position: sticky;

    a {
        color: $nav-text-color;
        &:hover {
            color: $nav-text-color-hover;
        }
    }

    .router-link-exact-active {
        color: $nav-text-color-hover;
    }

    .navbar-brand {
        font-size: 29px;
        font-weight: 900;
        letter-spacing: -0.43px;
        span {
            font-weight: 400;
            letter-spacing: -0.43px;
        }
        &.router-link-exact-active {
            color: $nav-text-color;
        }
    }

    button.navbar-toggler {
        outline: none;
        padding: 0;

        svg {
            fill: $nav-text-color;
            width: 36px;
            height: 36px;
        }

        &[aria-expanded="true"] {
            svg {
               fill: $nav-text-color-hover;
            }
        }
    }

    .navbar-collapse {
        padding: 30px 20px;

        @include media-breakpoint-up(md) {
            position: relative;
            padding: 30px 0 0;
            display: none;
            z-index: 0;
            &.show {
                display: flex;
                flex-direction: row;
            }
        }

        @include media-breakpoint-up(lg) {
            padding: 0;
        }
    }

    hr {
        position: absolute;
        left: 0;
        top: 67px;
        z-index: 1;
        width: 100%;
        border-top: 1px solid $nav-border-color;
        @include media-breakpoint-up(lg) {
            display: none;
        }
    }

    .navbar-nav {
        position: relative;
        text-align: center;
        width: 100%;

        @include media-breakpoint-up(md) {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
        }

        @include media-breakpoint-up(lg) {
            justify-content: flex-end;
            margin-left: 20px;
        }

        @include media-breakpoint-up(xl) {
            margin-left: 100px;
            flex-wrap: nowrap;
        }

        .nav-link {
            font-size: 16px;
            font-weight: 600;
            padding-top: 1rem;
            padding-bottom: 1rem;

            @include media-breakpoint-up(md) {
                padding: 0.5rem 1.5rem;
            }
        }
        li {
            &:first-of-type {
                padding-left: 0;
                a {
                    @include media-breakpoint-down(md) {
                        padding-left: 0;
                    }
                }
            }

        }
    }
    .contact-us {
        text-align: center;
        margin-top: 15px;
        @include media-breakpoint-up(md) {
            margin-top: 0;
            margin-left: 20px;
        }
    }
}

nav.navbar.nav-dark {
    background-color: #000112;
    color: #ffffff;
    border-bottom: 1px solid #3c3b3b;
    @include media-breakpoint-up(lg) {
        border-bottom: none;
    }
    a {
        color: #ffffff;
        &:hover {
            color: $primary;
        }
    }
    .router-link-exact-active {
        color: $primary;
    }
    .navbar-brand.router-link-exact-active {
        color: #ffffff;
    }

    button.navbar-toggler svg {
        fill: #ffffff;
    }
    hr {
        border-top: 1px solid #3c3b3b;
    }
}

nav.navbar,
nav.navbar.nav-dark {
    .btn {
        color: #ffffff;
        &:hover {
            color: #ffffff;
        }
    }
}
</style>
